










































import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import EnergyBar from './energy-bar.vue'

const actModule = namespace('freeOrder')

@Component({
  name: 'fire-bar',
  components: {
    EnergyBar
  }
})
export default class FireBar extends Vue {
  @Prop() prizes!: any[]
  @Prop(Number) activeIndex!: number
  @Prop(Number) fireValue!: number
  @actModule.State prizeList!: any
  get targetOB() {
    const ob = this.prizes.filter(el => el.status === 3)[0]
    return ob
  }
  get allOpen() {
    if (this.prizeList) {
      const prize = this.prizeList.find((el: any) => el.grantStatus < 6)
      if (prize) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }
  get fireMaxValue() {
    return this.prizes[5].fireValue
  }
  get currentValue() {
    let realValue = this.fireValue
    if (this.fireValue > this.fireMaxValue) {
      realValue = this.fireMaxValue
    }
    return realValue
  }
  mounted() {
  }
  clickHandler(item: any) {
    this.$emit('click', item.level - 1)
  }
}
